import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OuNavInfo } from '../../models/sidebar/ou-nav-info';
import { SheetNavInfo } from '../../models/sidebar/sheet-nav-info';
import { AppNavInfo } from '../../models/sidebar/app-nav-info';
import { StorageService } from '../../services/general-utils';
import { PAGE_TITLE } from './../../../shared/constants/app.constants';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() ouItems: OuNavInfo[];

  // gestione 2^ sidebar
  backupNavItems: any[] = []; // backup nav items originali (da nav.ts) nel caso in cui debba essere ricaricata la sidebar
  currentUrl: string;
  secondLevelActive = false;

  subscriptions: Subscription = new Subscription();

  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private storageService: StorageService) {
  }

  ngOnInit() {
    this.currentUrl = this.router.url;

    // Cambio struttura sezione Risk Management per costruzione sottomenu sidebar
    this.ouItems.forEach(item => {
      if (item.title === 'Risk Management') {
        item.sections = [{
          index: 0,
          title: 'cambi',
          isOpen: false,
          apps: item.apps
        }];
        item.apps = [];
      }
    });

    this.checkUrl(this.ouItems);
    this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentUrl = (event as NavigationEnd).url;
      this.checkUrl(this.ouItems);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    if (!this.deviceService.isDesktop()) {
      document.getElementById('sidebar').classList.add('mobile');
    }
    if (this.deviceService.isMobile()) {
      this.toggleSidebar();
    }
    this.cdRef.detectChanges();
  }

  /* Funzione che esegue controllo sull'url corrente per switchare sidebar */
  private checkUrl(uoItems: any[]) {
    // Il titolo della pagina è del tipo: sheetTitle + ' - ' + appTitle
    const pageTitle = String(this.storageService.getItem(PAGE_TITLE));
    for (const uoItem of uoItems) {
      uoItem.isOpen = false;
      for (const app of uoItem.apps) {
        app.isOpen = false;
        if (app.sheets.length > 0 || app.groups.length > 0) {
          for (const sheet of app.sheets) {
            let childTitle = String(sheet.title + ' - ' + app.title).replace(/\//g, "");
            sheet.active = false;
            if (pageTitle === childTitle) {
              uoItem.isOpen = true;
              app.isOpen = true;
              sheet.active = true;
            }
          }

          for (const group of app.groups) {
            group.isOpen = false;
            for (const sheet of group.sheets) {
              let childTitle = String(sheet.title + ' - ' + app.title).replace(/\//g, "");
              sheet.active = false;
              if (pageTitle === childTitle) {
                uoItem.isOpen = true;
                app.isOpen = true;
                group.isOpen = true;
                sheet.active = true;
              }
            }
          }
        } else {
          if (pageTitle === app.title.replace(/\//g, "")) {
            uoItem.isOpen = true;
            app.isOpen = true;
          }
        }
      }

      if (uoItem.sections) {
        for (const section of uoItem.sections) {
          section.isOpen = false;
          for (const app of section.apps) {
            if (pageTitle === app.title) {
              uoItem.isOpen = true;
              section.isOpen = true;
            }
          }
        }
      }
    }
  }

  checkUrlIncluded(navItemUrl: string): boolean {
    return this.currentUrl.includes(navItemUrl);
  }

  checkDropdownOnLoading(navItemUrl: string): boolean {
    return this.checkUrlIncluded(navItemUrl) && !this.isMinimized();
  }

  toggleSidebar() {
    if (this.deviceService.isDesktop()) {
      document.getElementById('main_sidebar').classList.toggle('isMinimized'); // per gestione z-index!
      document.getElementById('sidebar').classList.toggle('minimized');
      document.getElementById('sidebarCollapse').classList.toggle('active');
      document.getElementById('sidebarCollapse').classList.toggle('open');
    } else {
      // gestione "mobile"
      document.getElementById('sidebar').classList.remove('active');
      document.getElementById('blockScreen').classList.remove('active');
    }
  }

  isMinimized(): boolean {
    return document.getElementById('sidebar').classList.contains('minimized');
  }

  /* Funzione che cambia lo stato del dropdown dell'unità organizzativa da aperto a chiuso e viceversa */
  changeUoDropDownState(ouIndex: number) {
    this.ouItems[ouIndex].isOpen = !this.ouItems[ouIndex].isOpen;
  }

  /* Funzione che cambia lo stato del dropdown dell'app da aperto a chiuso e viceversa */
  changeAppDropDownState(ouIndex: number, appIndex: number) {
    this.ouItems[ouIndex].apps[appIndex].isOpen = !this.ouItems[ouIndex].apps[appIndex].isOpen;
  }

  /* Funzione che cambia lo stato del dropdown di un gruppo da aperto a chiuso e viceversa */
  changeGroupDropDownState(ouIndex: number, appIndex: number, groupIndex: number) {
    this.ouItems[ouIndex].apps[appIndex].groups[groupIndex].isOpen = !this.ouItems[ouIndex].apps[appIndex].groups[groupIndex].isOpen;
  }

  /* Funzione che cambia lo stato del dropdown di una sezione da aperto a chiuso e viceversa */
  changeSectionDropDownState(ouIndex: number, sectionIndex: number) {
    this.ouItems[ouIndex].sections[sectionIndex].isOpen = !this.ouItems[ouIndex].sections[sectionIndex].isOpen;
  }

  navigate(sheetItem: SheetNavInfo, appItem: AppNavInfo) {
    let pageTitle = sheetItem.title + ' - ' + appItem.title;
    pageTitle = pageTitle.replace(/\//g, "");
    this.storageService.setItem(PAGE_TITLE, pageTitle);
    this.router.navigate(['/qlik-mashup/' + sheetItem.appId + '/' + sheetItem.sheetId + '/' + pageTitle]);
  }

  changeTitle(title: string) {
    this.storageService.setItem(PAGE_TITLE, title);
  }

}
